export default "__VITE_ASSET__d47b033b__"